import { useContext } from "react";
import { CircleLoader, PageHeader } from "components";
import { Filters, Results } from './components';
import { customersSummaryContext } from './CustomersSummaryContext';
import { LocalizationIds } from "helpers/Localizations";
import { useIntl } from "react-intl";


let CustomersSummary = () => {
    let { formatMessage } = useIntl();
    let service = useContext(customersSummaryContext);

    return (
        <>
            <PageHeader pageTitle={formatMessage({ id: LocalizationIds.CustomersSummary })} />
            <Filters />
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false && <Results />}
        </>
    );
}

export default CustomersSummary;